<template>
	<div class="table-responsive">
		<table class="table table-striped tabela">
			<thead>
				<tr>
					<th>Pos</th>
					<th class="text-center">Dorsal</th>
					<th>Nome</th>
					<th class="text-center">Escalão</th>
					<th class="text-center">Equipa</th>
					<th class="text-right">Tempo</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(a, index) in dados" :a="a" :index="index" v-if="index < num">
					<td>{{ index + 1 }}</td>
					<td class="text-center">{{ a.dorsal }}</td>
					<td>{{ a.nome }}</td>
					<td class="text-center">{{ a.escalao }}</td>
					<td class="text-center">{{ a.equipa }}</td>
					<td class="text-right">{{ a.tempo }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: [
		'dados',
		'num'
	]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// TabelaCompleta.vue?59c734d6